import { Link } from "react-router-dom";
export default function UpiQRPage() {
  return (
    <div style={{ background: "#020617", color: "white", minHeight: "100vh", padding: "60px 24px", fontFamily: "sans-serif", maxWidth: 900, margin: "0 auto" }}>
      <h1 style={{ fontSize: 36, fontWeight: 900, marginBottom: 16 }}>UPI Payment QR Code Generator</h1>
      <p style={{ color: "#94a3b8", fontSize: 16, lineHeight: 1.8, marginBottom: 24 }}>
        Create a UPI QR code for your business in seconds. When customers scan your UPI QR code, 
        PhonePe, Google Pay, Paytm, or any UPI app opens automatically with your payment details 
        pre-filled. Perfect for shops, restaurants, freelancers, and street vendors.
      </p>
      <h2 style={{ fontSize: 22, marginBottom: 12 }}>How UPI QR Codes Work on Digitoly</h2>
      <ul style={{ color: "#94a3b8", lineHeight: 2, paddingLeft: 20 }}>
        <li>Enter your UPI ID (e.g. yourname@paytm or 9999999999@upi)</li>
        <li>Set your display name and optional fixed amount</li>
        <li>Download your QR as PNG, JPG, SVG, or PDF</li>
        <li>Every scan is tracked — see who paid, when, and from where</li>
        <li>Works with PhonePe, Google Pay, Paytm, BHIM, Amazon Pay</li>
      </ul>
      <Link to="/login" style={{ display: "inline-block", marginTop: 32, padding: "16px 36px", background: "#ef4444", color: "white", borderRadius: 14, fontWeight: 900, textDecoration: "none", textTransform: "uppercase" }}>
        Create Your UPI QR Free →
      </Link>
    </div>
  );
}